<template>
  <div>
    <!-- ===== PREVIEW FIXO ===== -->
    <div class="row" style="margin-top: 10px;">
      <div class="col-md-12 text-left">
        <!-- Se tiver foto -->
        <div v-if="temFotoExistente" class="preview-box">
          <img :src="previewSrc" class="preview-img" alt="Foto cadastrada" />

          <base-button
            class="mt-2"
            type="info"
            round
            block
            size="lg"
            @click="$emit('click-alterar')"
          >
            <i class="tim-icons icon-camera-18" /> Alterar Foto
          </base-button>

          <base-button
            class="mt-2"
            type="danger"
            round
            block
            size="lg"
            @click="excluirFotoExistente"
          >
            <i class="tim-icons icon-trash-simple" /> Excluir Foto
          </base-button>
        </div>

        <!-- Se NÃO tiver foto -->
        <div v-else class="preview-empty">
          <div class="empty-square">
            <span class="empty-text">Não tem foto cadastrada</span>
          </div>
          <base-button
            class="mt-2"
            type="success"
            round
            block
            size="lg"
            @click="$emit('click-alterar')"
          >
            <i class="tim-icons icon-simple-add" /> Adicionar Foto
          </base-button>
        </div>
      </div>
    </div>

    <Carregando v-if="isLoading" />
  </div>
</template>

<script>
import Carregando from "../Loads/Carregando.vue";
import swal from "sweetalert2";

export default {
  name: "BasePreviewFotoFacial",
  components: { Carregando },

  props: {
    cpf: { type: String, default: "" },
    verificarFotoExistente: { type: Boolean, default: false },
    hasLoading: { type: Boolean, default: false },

    apiBaseRecFacial: {
      type: String,
      default: () => process.env.VUE_APP_API_ADDRESS_REC_FACIAL,
    },
    endpointBuscarFoto: { type: String, default: "/getFotoRecente" },
    endpointExcluirFoto: { type: String, default: "/deleteFotos" },
  },

  data() {
    return {
      isLoading: false,
      fotoExistenteBase64: "",
      previewObjectUrl: "",

      // controle de chamadas
      _buscandoFoto: false,
      _cpfFotoCarregada: "",
    };
  },

  computed: {
    temFotoExistente() {
      return !!this.fotoExistenteBase64;
    },
    previewSrc() {
      return this.previewObjectUrl || "";
    },
  },

  watch: {
    cpf: {
      immediate: true,
      handler() {
        this.buscarFotoUmaVez();
      },
    },
  },

  beforeDestroy() {
    this.revokePreviewUrl();
  },

  methods: {
    cpfSanitizado() {
      return (this.cpf || "").replace(/\D/g, "");
    },

    async buscarFotoUmaVez() {
      if (!this.verificarFotoExistente) return;

      const cpfLimpo = this.cpfSanitizado();
      if (!cpfLimpo) {
        this.limparFoto();
        return;
      }

      if (this._buscandoFoto) return;
      if (this._cpfFotoCarregada === cpfLimpo) return;

      this._buscandoFoto = true;
      try {
        await this.buscarFotoExistente(cpfLimpo);
        this._cpfFotoCarregada = cpfLimpo;
      } finally {
        this._buscandoFoto = false;
      }
    },

    async buscarFotoExistente(cpfLimpo) {
      try {
        if (this.hasLoading) this.isLoading = true;

        const form = new FormData();
        form.append("nrCpf", Number(cpfLimpo));

        const response = await this.axios.post(
          `${this.apiBaseRecFacial}${this.endpointBuscarFoto}`,
          form
        );

        const raw = response.data.ImagemRecente[0] || "";

        this.fotoExistenteBase64 = this.normalizarBase64(
          this.removerPrefixoDataUrl(raw)
        );

        this.$emit("foto-carregada", this.temFotoExistente);
        this.criarPreview();
      } catch {
        this.limparFoto();
        this.$emit("foto-carregada", false);
      } finally {
        if (this.hasLoading) this.isLoading = false;
      }
    },

    async excluirFotoExistente() {
      const cpfLimpo = this.cpfSanitizado();
      if (!cpfLimpo) return;

      const confirm = await swal.fire({
        title: "Excluir foto?",
        text: "Essa ação não pode ser desfeita.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, excluir",
        cancelButtonText: "Cancelar",
      });

      if (!confirm.value) return;

      try {
        if (this.hasLoading) this.isLoading = true;

        const form = new FormData();
        form.append("nrCpf", cpfLimpo);

        await this.axios.post(
          `${this.apiBaseRecFacial}${this.endpointExcluirFoto}`,
          form
        );

        this.limparFoto();
        this.$emit("foto-excluida", true);
        this.$emit("foto-carregada", false);

        swal.fire({
          title: "Pronto!",
          text: "Foto excluída com sucesso.",
          icon: "success",
          timer: 1800,
          showConfirmButton: false,
        });
      } catch {
        swal.fire({
          title: "Erro",
          text: "Não foi possível excluir a foto.",
          icon: "error",
        });
      } finally {
        if (this.hasLoading) this.isLoading = false;
      }
    },

    criarPreview() {
      this.revokePreviewUrl();
      if (!this.fotoExistenteBase64) return;

      const mime = this.detectarMime(this.fotoExistenteBase64);
      const blob = this.base64ToBlob(this.fotoExistenteBase64, mime);
      this.previewObjectUrl = URL.createObjectURL(blob);
    },

    limparFoto() {
      this.fotoExistenteBase64 = "";
      this._cpfFotoCarregada = "";
      this.revokePreviewUrl();
    },

    revokePreviewUrl() {
      if (this.previewObjectUrl) {
        URL.revokeObjectURL(this.previewObjectUrl);
        this.previewObjectUrl = "";
      }
    },

    removerPrefixoDataUrl(value) {
      return String(value || "").replace(
        /^data:image\/[a-zA-Z0-9.+-]+;base64,/,
        ""
      );
    },

    normalizarBase64(b64) {
      let s = String(b64 || "").replace(/\s/g, "");
      s = s.replace(/-/g, "+").replace(/_/g, "/");
      const pad = s.length % 4;
      if (pad === 2) s += "==";
      else if (pad === 3) s += "=";
      else if (pad === 1) s = s.slice(0, -1);
      return s;
    },

    detectarMime(base64) {
      if (base64.startsWith("/9j")) return "image/jpeg";
      if (base64.startsWith("iVBOR")) return "image/png";
      if (base64.startsWith("R0lGOD")) return "image/gif";
      return "image/jpeg";
    },

    base64ToBlob(base64, mime) {
      const byteChars = atob(base64);
      const byteNumbers = new Array(byteChars.length);
      for (let i = 0; i < byteChars.length; i++) {
        byteNumbers[i] = byteChars.charCodeAt(i);
      }
      return new Blob([new Uint8Array(byteNumbers)], { type: mime });
    },
  },
};
</script>

<style scoped>
.preview-box {
  width: 100%;
  max-width: 420px;
}

.preview-img {
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fff;
}

.preview-empty {
  width: 100%;
  max-width: 420px;
}

.empty-square {
  width: 100%;
  height: 220px;
  border: 2px dashed #bdbdbd;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafafa;
}

.empty-text {
  color: #8d8d8d;
  font-size: 14px;
}
</style>
